"use client";

import { cn } from "@/lib/utils";
import { LEAD_TYPE_CONFIG } from "@/lib/lead-types";

interface LeadTypeBadgeProps {
  type: string;
  /** "sm" (default) — standard pill with dot; "xs" — compact pill with smaller dot */
  size?: "sm" | "xs";
  className?: string;
}

export function LeadTypeBadge({ type, size = "sm", className }: LeadTypeBadgeProps) {
  const cfg = LEAD_TYPE_CONFIG[type];
  if (!cfg) {
    return (
      <span className={cn("text-xs text-muted-foreground", className)}>
        {type || "—"}
      </span>
    );
  }

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full font-medium",
        size === "xs"
          ? "px-1.5 py-0.5 text-[10px] gap-1"
          : "px-2.5 py-0.5 text-xs",
        cfg.pill,
        className,
      )}
    >
      <span
        className={cn(
          "rounded-full shrink-0",
          size === "xs" ? "h-1 w-1" : "h-1.5 w-1.5",
          cfg.dot,
        )}
      />
      {cfg.label}
    </span>
  );
}
